import React, { useState } from "react";
import { Stepper, Step } from "react-form-stepper";

import HelmetWrapper from "../../components/common/Layouts/HelmetWrapper";
import Header from "../../components/common/Layouts/Header";
import Footer from "../../components/common/Layouts/Footer";

// Import the sub-pages
import VenueAddEditPage from "../Venues/VenueAddEditPage";
import EventAddEditPage from "../Events/EventAddEditPage";

export default function HostEventPage() {
    const [currentStep, setCurrentStep] = useState(0);

    // Function to proceed to the next step
    const handleNextStep = () => {
        setCurrentStep(1);
        window.scrollTo(0, 0); // Scroll to top when changing steps
    };

    return (
        <>
            {/* SEO HELMET WRAPPER */}
            <HelmetWrapper
                title="Host Event - Pingvite"
                description="Host your event on Pingvite in two simple steps: Create your venue, then create your event."
                keywords="Host Event Pingvite, Create Event, Create Venue"
            />
            <Header isHome={false} />
            <div className="container" style={{ paddingTop: "2rem" }}>
                <div className="pageCard">
                    <Stepper
                        activeStep={currentStep}
                        styleConfig={{
                            activeBgColor: '#731997',    /* Professional Purple from user list */
                            completedBgColor: '#4611C2', /* Professional Dark Violet from user list */
                            inactiveBgColor: '#d9d9d9',
                        }}
                    >
                        <Step label="Create Venue" />
                        <Step label="Create Event" />
                    </Stepper>
                    <div className="steps-content">
                        {currentStep === 0 && <VenueAddEditPage isEmbedded={true} onNext={handleNextStep} />}
                        {currentStep === 1 && <EventAddEditPage isEmbedded={true} />}
                    </div>
                </div>
            </div>
            {/* FOOTER */}
            <Footer />
        </>
    );
}
